export enum Sorting {
  asc = 'ASC',
  desc = 'DESC',
  def = 'DEF'
}
